import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-black border-y border-navy-border" data-id="element-126" data-mp="1o2vfqkp72f4g">
      <div className="max-w-4xl mx-auto" data-id="element-127" data-mp="223y26yk3prfw">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-navy-card to-black border border-gold/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-128" data-mp="222n1x8pv71tj">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold-gradient" data-id="element-129" data-mp="1j5vbmfbwnmfz"></div>

          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gold/10 text-gold mb-8" data-id="element-130" data-mp="1ebr2pqj2x4c9">
            <ShieldCheck size={48} data-id="element-131" data-mp="lp6bqr6imu98" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-132" data-mp="lodf4j19tl4t">
            🛡️ Complete 7-Day Money-Back Guarantee
          </h2>

          <div className="space-y-6 text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-133" data-mp="oxoz5u2peqwo">
            <p data-id="element-134" data-mp="twryqyzx04x9">
              Open the complete teaching system. Explore the 5 bonuses. Use the
              material in your most challenging class this week.
            </p>
            <p className="font-medium text-white" data-id="element-135" data-mp="12pmtuzvo4k9b">
              If you feel the material is not clear, practical or useful for
              your teaching needs — contact us within 7 days.
            </p>
            <p className="text-gold-light font-bold text-xl" data-id="element-136" data-mp="b0a7eioza71j">
              We will refund 100% of your money. No questions. No forms. No
              complications.
            </p>
            <p className="text-sm text-gray-400 mt-8" data-id="element-137" data-mp="k1hr9vqqz5c3">
              Because if the material does not deliver the value we promise, we
              do not want to keep your money.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}